import React, { useState, useEffect } from "react";
import { DivTag } from "../../../Components/Tags/Tags";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { HeadTag, InputField } from "../../../Components/Tags/Tags";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import GaugeChart from "react-gauge-chart";
import {
  checkCrifCreditScore,
  V2VerifyMobile,
} from "../../../Services/EquifaxCScore/highmark";
import CrifScoreReportModal from "./CrifScoreReport";
import html2pdf from "html2pdf.js";
import { CrifCreditScoredata, EV2MobileVerify } from "./data";
import Loader from "../../../Loader";
import { fetchProfile } from "../../../Services/profile/profileservice";
import { FaHandPointLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

const CrifCreditScore = () => {
  const [cusName, setCusName] = useState();
  const [mobile, setMobile] = useState("");
  const [panNo, setPanNo] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // const [creditScore, setCreditScore] = useState(CrifCreditScoredata?.data?.credit_report?.SCORES?.SCORE?.['SCORE-VALUE']);
  const [creditScore, setCreditScore] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [docType, setDocType] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [profileData, setProfileData] = useState([]);
  const [Equifaxv2Report, setEquifaxv2Report] = useState(null); // Put null i no
  const [Equifaxv2Error, setEquifaxv2Error] = useState(null); // Put Null if no
  const [submittedName, setSubmittedName] = useState("");
  const [submittedMobile, setSubmittedMobile] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isModalOpenMobile, setIsModalOpenMobile] = useState(false);
  const [mobileResponseData, setMobileResponseData] = useState(null);
  const [afterVerifyMobPan, setAfterVerifyMobPan] = useState("");
  const [afterVerifyMobAadhar, setAfterVerifyMobAadhaar] = useState("");
  const [afterMobName, setAfterMobName] = useState("");
  const [triggerVerifyContine, setTriggerVerifyContinue] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(
    sessionStorage.getItem("verifyClicked") === "true",
  );

  const maxScore = 900;
  const validateForm = () => {
    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.firstName = "First Name is required.";
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Last Name is required.";
    }

    // Validate mobile
    if (mobile === "") {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (panNo === "") {
      newErrors.panNo = "PAN number is required.";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase().trim())) {
      newErrors.panNo = "Enter a valid PAN number (e.g., ABCDE1234F).";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    try {
      // Validate the form first
      const isValid = validateForm();
      if (!isValid) {
        setEquifaxv2Report(null);
        setEquifaxv2Error(null);
        return;
      }
      setShowLoader(true);
      await GetCrifCreditScore();

      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      showErrorToast("Validate the Required Field");
      setShowLoader(false);
    }
  };

  const handleDownloadPDF = () => {
    setIsDownloading(true);
    setTimeout(() => {
      const element = document.getElementById("CreditReport");

      if (element) {
        element.classList.remove("hidden");
        const clonedElement = element.cloneNode(true);
        clonedElement.style.maxHeight = "none";
        clonedElement.style.overflow = "visible";
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.appendChild(clonedElement);
        document.body.appendChild(tempDiv);
        html2pdf()
          .from(clonedElement)
          .set({
            margin: [0.2, 0.2, 0.2, 0.2],
            filename: "Crif Credit Report.pdf",
            image: { type: "jpeg", quality: 0.9 },
            html2canvas: { scale: 2, backgroundColor: "white" },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
          })
          .save()
          .then(() => {
            document.body.removeChild(tempDiv);
            element.classList.add("hidden");
            setIsDownloading(false); //  Stop loading
          })
          .catch(() => {
            showErrorToast("Failed to generate PDF");
            element.classList.add("hidden");
            setIsDownloading(false); //  Stop loading
          });
      } else {
        showErrorToast("No data found to download");
      }
    }, 500);
  };

  async function GetCrifCreditScore() {
    try {
      setShowLoader(true);
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile: mobile,
        pan: panNo,
        first_name: firstName,
        last_name: lastName,
        consent: "Y",
      };
      const response = await checkCrifCreditScore(payload);
      //  console.log("crif vvv11", response);
      const statusCode = response?.status?.code || response?.status;

      if (
        statusCode === 403 &&
        statusCode.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "Insufficient balance in wallet."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message ===
          "Your service is not available in this environment."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Your service is not available in this environment.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return;
      }
      console.log("res" ,response?.data?.report_data?.crifData?.SCORES?.SCORE?.['SCORE-VALUE'] || 0);

      if (statusCode === 200) {
        //  Success

        

        setEquifaxv2Report(response || response?.data);
        setCreditScore(
          Number(
            response?.data?.report_data?.crifData?.SCORES?.SCORE?.['SCORE-VALUE'] || 0,
          ),
        );
        setSubmittedName(cusName);
        setCusName("");
        setMobile("");
        setPanNo("");
        showSuccessToast(
          response?.credit_report_message?.message ||
            response?.message ||
            "Credit score fetched successfully.",
        );
      } else {
        //  All other errors
        setEquifaxv2Error(response?.error || response?.data || {}); // Now capturing error block
        setEquifaxv2Report(null);
        // setModalOpen(true);
        showErrorToast(
          response?.data?.message || // Fallback message in response.data
            response?.message || // Type 1 error (top-level message)
            response?.data?.error?.credit_report_message?.message || // Type 2 error
            response?.data?.error || // Direct string error like "Insufficient balance.
            "Something went wrong.", // Default fallback
        );
      }
    } catch (error) {
      console.error("Error in Crif Score:", error);
      setEquifaxv2Report(null);
      setEquifaxv2Error(error);
      showErrorToast("Something went wrong.");
    } finally {
      setShowLoader(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    }
    fetchProfileData();
  }, []);

  const handleVerifyMobile = async () => {
    const newErrors = {};

    // Only validate mobile
    if (!mobile.trim()) {
      newErrors.mobile = "Mobile is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoader(true);
      setIsVerifyDisabled(true);
      sessionStorage.setItem("verifyClicked", "true");

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobile,
        first_name: firstName,
        last_name: lastName,
      };

      const response = await V2VerifyMobile(payload);

      if (
        response.status === 403 &&
        response.data.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "Insufficient balance in wallet."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance in wallet.");
        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");

        return;
      }

      setMobileResponseData(response || response?.data || response?.data?.data);
      if (response?.data?.result !== null) {
        showSuccessToast(
          response?.status?.message ||
            response?.message ||
            "Consumer Details Fetched",
        );
      } else {
        showErrorToast(
          response?.status?.message || response?.message || "No Records Found",
        );
      }

      setShowLoader(false);
      setIsLoading(false);
      setIsModalOpenMobile(true);
      setIsVerifyDisabled(false);
    } catch (error) {
      console.error("Error verifying Consumer:", error);
      setIsVerifyDisabled(false);
      setShowLoader(false);
      setIsLoading(false);
    }
  };

  // Reset on page load
  useEffect(() => {
    sessionStorage.removeItem("verifyClicked");
  }, []);

  const VerifyContinue = () => {
    setTriggerVerifyContinue(true);
    setIsModalOpenMobile(false);
  };

  useEffect(() => {
    if (triggerVerifyContine) {
      // Priority: PAN first, then Aadhaar
      if (afterVerifyMobPan && !afterVerifyMobPan.startsWith("XXXX")) {
        setDocType("pan");
        setPanNo(afterVerifyMobPan);
      } else if (
        afterVerifyMobAadhar &&
        !afterVerifyMobAadhar.startsWith("XXXX")
      ) {
        setDocType("aadhaar");
        setPanNo(afterVerifyMobAadhar);
      }

      if (afterMobName) {
        const name = afterMobName || "";
        const nameParts = name.trim().split(" ");
        const firstNameFromName = nameParts[0] || "";
        const lastNameFromName =
          nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

        setFirstName(firstNameFromName);
        setLastName(lastNameFromName);

        //  setCusName(afterMobName);
      }

      // Reset trigger
      setTriggerVerifyContinue(false);
    }
  }, [
    triggerVerifyContine,
    afterVerifyMobPan,
    afterVerifyMobAadhar,
    afterMobName,
  ]);

  const accSummary =
    Equifaxv2Report?.report_data?.crifData?.["ACCOUNTS-SUMMARY"] ||
    Equifaxv2Report?.data?.report_data?.crifData?.["ACCOUNTS-SUMMARY"] ||
    Equifaxv2Report?.data?.credit_report?.["ACCOUNTS-SUMMARY"] ||
    {};
  const primary = accSummary["PRIMARY-ACCOUNTS-SUMMARY"] || {};
  const derived = accSummary["DERIVED-ATTRIBUTES"] || {};

  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading="Crif Credit Score" />
      <DivTag className="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-white mt-2 shadow-md rounded-md">
        {/* Mobile */}

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            First Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="first_name"
            name="first_name"
            value={firstName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full required"
            placeholder="Enter First Name"
            onChange={(e) => {
              setFirstName(e.target.value);
              setErrors((prev) => ({ ...prev, firstName: "" }));
            }}
          />
          {errors.firstName && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.firstName}
            </p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            Last Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="last_name"
            name="last_name"
            value={lastName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border required border-blue-600 w-full"
            placeholder="Enter Last Name"
            onChange={(e) => {
              setLastName(e.target.value);
              setErrors((prev) => ({ ...prev, lastName: "" }));
            }}
          />
          {errors.lastName && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.lastName}
            </p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <div className="flex items-center justify-between mb-1">
            <HeadTag className="text-md font-serif">
              Mobile <strong className="text-red-700">*</strong>
            </HeadTag>

            {/* Small Button beside label */}
            {/* <button
                            type="button"
                            onClick={() => setIsModalOpenMobile(true)}
                            className="text-sm bg-green-600 text-white px-1 rounded hover:bg-green-700"
                        >
                            View

                        </button> */}
          </div>

          {/* Input + Button */}
          <div className="flex">
            <InputField
              type="text"
              placeholder="Enter Mobile"
              className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
              name="mobile"
              id="mobile"
              onChange={(e) => setMobile(e.target.value)}
            />
            {/* <button
                            type="button"
                            onClick={handleVerifyMobile}
                            disabled={isVerifyDisabled}
                            className={`bg-blue-600 text-white p-1 hover:bg-blue-700 ${isVerifyDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            Verify
                        </button> */}
          </div>

          {errors.mobile && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.mobile}
            </p>
          )}

          {/* Modal */}
          {isModalOpenMobile && (
            <MobileDataModal
              setAfterMobName={setAfterMobName}
              mobileResponseData={mobileResponseData}
              setAfterVerifyMobPan={setAfterVerifyMobPan}
              setAfterVerifyMobAadhaar={setAfterVerifyMobAadhaar}
              VerifyContinue={VerifyContinue}
              onClose={() => setIsModalOpenMobile(false)}
            />
          )}
        </DivTag>

        {/* Doc No. */}
        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            {docType === "pan"
              ? "Pan No."
              : docType === "aadhaar"
                ? "Aadhar No."
                : "Pan."}
            <strong className="text-red-700">*</strong>
          </HeadTag>

          <InputField
            type="text"
            placeholder={
              docType === "pan"
                ? "Enter Pan"
                : docType === "aadhaar"
                  ? "Enter Aadhar"
                  : "Enter Doc No."
            }
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
            name="pan_no"
            id="pan_no"
            value={panNo}
            onChange={(e) => setPanNo(e.target.value)}
            disabled={!docType} // Optional: disable if no DocType selected
          />
          {errors.panNo && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.panNo}
            </p>
          )}
        </DivTag>
      </DivTag>
      <div className="flex justify-center">
        <button
          className={`rounded-md p-1 bg-blue-700 text-white mt-4 mb-1 h-8 px-3 ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
          onClick={handlesubmit}
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Get Credit Report"}
        </button>
      </div>

      <div className="w-full text-center">
        {errors.identification && (
          <p className="text-red-600 text-sm font-mono">
            {errors.identification}
          </p>
        )}
      </div>

      {Equifaxv2Report || Equifaxv2Error ? (
        <div class="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
          <span className="text-center font-bold md:text-xl">
            Hey{" "}
            {Equifaxv2Report?.report_data?.REQUEST?.NAME ||
            Equifaxv2Report?.credit_report?.REQUEST?.NAME
              ? Equifaxv2Report.report_data.REQUEST.NAME
              : Equifaxv2Error?.first_name ||
                Equifaxv2Error?.error?.first_name ||
                "N/A"}
            !
          </span>

          <h2 class="text-xl md:text-xl font-semibold text-center">
            Your Credit Score
          </h2>

          <div class="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
            <div class="w-full md:w-[400px] relative md:mt-10">
              <span
                class="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70
    top-[60px] left-5 
    "
              >
                Poor
              </span>
              <span
                class="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26
    left-[69px] top-[-7px] 
    "
              >
                Average
              </span>
              <span
                class="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20
    left-[12rem] mt-[-9px] rotate-20
    "
              >
                Good
              </span>
              <span
                class="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70
    ml-[16rem] mt-[3.5rem]
    "
              >
                Excellent
              </span>

              <GaugeChart
                id="gauge-chart1"
                nrOfLevels={3}
                percent={creditScore / maxScore} // Normalized value for gauge
                needleColor={"#00008b"}
                textColor={"transparent"} // Hides the percentage text
                needleBaseColor={"red"}
                arcsLength={[0.3, 0.3, 0.3, 0.3]}
                colors={["#cc0000", "#e6e600", "#cc6600", "#009900"]}
              />
              <p
                class="text-black font-bold text-xl md:text-2xl absolute bottom-12  md:bottom-[5.5rem] 
                    left-1/2 transform -translate-x-1/2"
              >
                {creditScore}
              </p>
            </div>

            <div class="flex flex-col items-center md:items-start">
              <div className="text-center font-bold md:text-xl">
                <ul className="text-left text-sm md:text-base space-y-1 mt-4">
                  <li>
                    <span className="font-bold">No of Accounts: </span>
                    {primary["PRIMARY-NUMBER-OF-ACCOUNTS"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">Active Accounts: </span>
                    {primary["PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">Total Balance Amount: </span>
                    {primary["PRIMARY-CURRENT-BALANCE"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">Total Past Due: </span>
                    {primary["PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">
                      Recent Accounts (last 6m):{" "}
                    </span>
                    {derived["NEW-ACCOUNTS-IN-LAST-SIX-MONTHS"] || "0"}
                  </li>
                  <li>
                    <span className="font-bold">New Delinq (last 6m): </span>
                    {derived["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"] || "0"}
                  </li>
                </ul>
              </div>

              <CrifScoreReportModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                Equifaxv2Report={Equifaxv2Report}
                Equifaxv2Error={Equifaxv2Error}
                submittedName={submittedName}
                submittedMobile={submittedMobile}
              />
              <div class="flex space-x-2 mt-4">
                <button
                  onClick={() => setModalOpen(true)}
                  class="bg-blue-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                >
                  View
                </button>
                {/* <button
                                        className="bg-red-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                                        onClick={handleDownloadPDF}
                                        disabled={isDownloading}
                                    >
                                        {isDownloading ? "Downloading..." : "Download"}
                                    </button> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="flex justify-center">
        <div class="flex flex-col items-center bg-gray-200 rounded-md shadow-lg shadow-blue-800 md:w-3/4 w-full p-1">
          <h1 class="font-bold text-2xl text-red-600 underline mb-2">
            Instructions
          </h1>
          <h2 class="text-xl font-bold text-center text-gray-800 mb-2 underline">
            How to get Best Financial Credit Report in Crif?
          </h2>

          <ul class="list-decimal list-inside text-left text-gray-700">
            <li className="">
              Enter the correct customer’s First name and Last Name.
            </li>
            <li>
              Enter the Mobile Number which is registered in credit bureau
              company.
            </li>
            <li>Enter the correct PAN Number.</li>
            <li>
              The Crif Credit Report only provide the details Report of that
              consumer which is available in the Crif Bureau.
            </li>
            <li>
              If you didn’t get the report means you should try with different
              details or in another bureau company.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default CrifCreditScore;

const MobileDataModal = ({
  mobileResponseData,
  onClose,
  setAfterVerifyMobPan,
  setAfterVerifyMobAadhaar,
  setAfterMobName,
  VerifyContinue,
}) => {
  const rootData = mobileResponseData?.data || {};

  setAfterMobName(rootData?.name);
  setAfterVerifyMobPan(rootData?.pan);
  setAfterVerifyMobAadhaar(rootData?.aadhaar || "");

  const addresses = rootData?.address || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
        <div className="flex justify-between">
          <h2 className="text-2xl font-bold text-blue-700 border-b">
            Consumer Verification Details
          </h2>
          <button
            onClick={onClose}
            className="text-2xl text-red-600 hover:text-red-800"
          >
            ❌
          </button>
        </div>

        {rootData?.name && (
          <div className="w-full flex flex-col items-center mb-2">
            <h3 className="text-xl text-green-600 font-semibold text-center">
              Found In Experian
            </h3>
            <Link
              to="/ExperianScore2"
              className="flex items-center bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 gap-2 rounded transition duration-300 text-sm sm:text-base"
            >
              Result Found in Experian, Check Credit details in Experian for
              better result
              <FaHandPointLeft className="text-lg" />
            </Link>
          </div>
        )}

        {rootData?.idspay_message && (
          <div
            className={`flex justify-center border-2 p-3 rounded-lg ${
              rootData.idspay_message === "success"
                ? "bg-green-100 border-green-300"
                : "bg-red-100 border-red-300"
            }`}
          >
            <p
              className={`text-md font-serif ${
                rootData.idspay_message === "success"
                  ? "text-green-600"
                  : "text-red-500"
              }`}
            >
              {rootData.idspay_message}
            </p>
          </div>
        )}

        {/* Personal Info */}
        <div className="bg-blue-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-blue-600 mb-1">
            Personal Info
          </h3>
          <div className="grid grid-cols-2 gap-1 text-sm">
            <p>
              <strong>Full Name:</strong> {rootData?.name || "N/A"}
            </p>

            <p>
              <strong>DOB:</strong> {rootData?.dob || "N/A"}
            </p>
            <p>
              <strong>Gender:</strong> {rootData?.gender || "N/A"}
            </p>
            <p>
              <strong>PAN:</strong> {rootData?.pan || "N/A"}
            </p>
            <p>
              <strong>Email:</strong> {rootData?.email || "N/A"}
            </p>
          </div>
        </div>

        {/* Addresses */}
        <div className="bg-yellow-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-yellow-600 mb-2">
            Addresses
          </h3>
          {addresses.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-300 rounded-md">
                <thead className="bg-yellow-100 text-gray-700">
                  <tr>
                    <th className="border px-2 py-1 text-left">Address #</th>
                    <th className="border px-2 py-1 text-left">Full Address</th>
                    <th className="border px-2 py-1 text-left">State</th>
                    <th className="border px-2 py-1 text-left">Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => (
                    <tr key={index} className="border-t">
                      <td className="border px-2 py-1">Address {index + 1}</td>
                      <td className="border px-2 py-1">
                        {[
                          address.first_line_of_address,
                          address.second_line_of_address,
                          address.third_line_of_address,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </td>
                      <td className="border px-2 py-1">
                        {address.state || "N/A"}
                      </td>
                      <td className="border px-2 py-1">
                        {address.postal_code || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-sm">No address information available.</p>
          )}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-center gap-3 mt-3">
          <button
            onClick={VerifyContinue}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 transition"
          >
            Verify & Continue
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
